import { getData, putData } from "../plugins/ApiCalls"

export function fetchLeadNotificationSetting(data) {
  return getData('lead-notifications' + (data && data.id ? '/' + data.id : ''))
}

export function updateLeadNotificationSetting(data) {
  return putData('lead-notifications/' + data.id, data)
}
